import {
  Box,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";

const FilterItems = ({
  roles,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
}) => {
  return (
    <Grid container spacing={2}>
      {/* <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Full Name
        </InputLabel>
        <TextField
          variant="outlined"
          name="employeeName"
          value={filterData.employeeName}
          onChange={handleChangeFilter("employeeName")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid> */}

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Username
        </InputLabel>
        <TextField
          variant="outlined"
          name="userName"
          value={filterData.userName}
          onChange={handleChangeFilter("userName")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Active
        </InputLabel>
        <FormControl fullWidth>
          <Select
            value={filterData.active}
            onChange={(e) => handleChangeFilter("active")(e)}
            variant="outlined"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleFilter();
            }}
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      {/* <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Employee ID
        </InputLabel>
        <TextField
          variant="outlined"
          name="employeeId"
          value={filterData.employeeId}
          onChange={(e) => handleChangeFilter("employeeId")(e)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid> */}

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Role
        </InputLabel>
        <FormControl fullWidth>
          <Select
            value={filterData.role}
            onChange={(e) => handleChangeFilter("role")(e)}
            variant="outlined"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleFilter();
            }}
          >
            {roles &&
              roles.map((role) => (
                <MenuItem key={role.id} value={role.id}>
                  {role?.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{ mr: 1, color: "#7152F3" }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilter}
            sx={{ backgroundColor: "#7152F3" }}
          >
            Filter{" "}
            <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
